import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { STATUS_COLORS } from './colors';
import { formatDay } from './formatDay';

// Recharts lists bars before lines; pin the legend to Created, Open, Fixed.
const LEGEND_ORDER = ['opened', 'open', 'fixed'];

function BugBacklogChart({ data }) {
  return (
    <div>
      <div className="sense-shield-panel-title">Open Bug Backlog Over Time</div>
      <p className="sense-shield-panel-description">Bugs still open at the end of each day in the selected period (each week for ranges over two months)</p>
      <div className="sense-shield-panel-content">
        {!data || data.length === 0 ? (
          <div className="sense-shield-empty">No backlog data available</div>
        ) : (
          <ResponsiveContainer width="100%" height={220}>
            <ComposedChart data={data} margin={{ top: 30, right: 20, left: 0, bottom: 10 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={formatDay} interval="preserveStartEnd" minTickGap={16} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip />
              <Legend verticalAlign="top" align="left" wrapperStyle={{ fontSize: 12 }} itemSorter={(item) => LEGEND_ORDER.indexOf(item.dataKey)} />
              <Bar dataKey="opened" name="Created" fill="#8b8b8b" />
              <Line type="monotone" dataKey="open" name="Open" stroke={STATUS_COLORS.fail} strokeWidth={2} dot={{ r: 3 }} />
              <Bar dataKey="fixed" name="Fixed" fill={STATUS_COLORS.passed} />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}

export default BugBacklogChart;
